import React from 'react';

import { getCsrfToken } from '@betterment/js-runtime';
import { Button, ButtonProps } from '@betterment/samba-react';

export interface RailsFormProps {
  method: 'post' | 'put' | 'patch' | 'get' | 'delete';
  action: string;
  shouldOpenNewTab?: boolean;
  'data-testId'?: string;
}

const FormButton: React.FC<React.PropsWithChildren<RailsFormProps & ButtonProps>> = ({
  method = 'post',
  action,
  shouldOpenNewTab = false,
  'data-testId': dataTestId,
  children,
  ...buttonProps
}) => {
  return (
    <form data-testid={dataTestId} action={action} method={method} target={shouldOpenNewTab ? '_blank' : undefined}>
      <input type="hidden" name="authenticity_token" value={getCsrfToken() ?? undefined} />
      <input type="hidden" name="_method" value={method} />
      <Button type="submit" {...buttonProps}>
        {children}
      </Button>
    </form>
  );
};

export default FormButton;
